<script src="./_timer.js"></script>

<svelte:window on:blur={timeActivePause} on:focus={timeActiveResume}/>

<!-- <template src="./base.pug"></template>
<style src="./base.scss"></style> -->